import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const TippingManagementHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Tipping Management</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default TippingManagementHeader;
